import React, { Component, createRef } from 'react';
import { withStyles, TextField, Button, Container, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IAlert } from '../../core/models/alert';
import { ADD_ALERT, UPDATE_ALERT } from '../../core/handlers.actions';
import { TrixEditor } from 'react-trix';

const styles = (theme: any) => ({
    root: { '& .MuiTextField-root': { margin: theme.spacing(1), width: '100%' } },
    editBox: { borderTop: '2px solid #f50057', borderLeft: '2px solid #f50057', borderRight: '2px solid #f50057' },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '100%',
        marginBottom: 30
    },
    trixEditor: {
        marginBottom: 30,
        minWidth: 120,
        width: '100%',
    }
});

interface Props {
    classes: any;
    addAlert: (data: IAlert) => void;
    updateAlert: (data: IAlert) => void;
    reset: () => void;
    alertId:any;
    alerts:any;
}

interface State {
    name: any;
    title: any;
    content: any;
    contentRaw: any;
    type: any;
    _id: any;
    error: boolean;    
    editing: boolean;
}

class AlertForm extends Component<Props, State> {
    state: State = { name: '', title: '', content: '', contentRaw: '', type: '', error: false, _id: '', editing: false };
    editor = createRef();
    
    constructor(props: Props) {
        super(props);
        this.validateForm = this.validateForm.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.submit = this.submit.bind(this);
        this.update = this.update.bind(this);
        this.cancel = this.cancel.bind(this);
        this.textFieldChange = this.textFieldChange.bind(this);
        this.setAlertUpdate = this.setAlertUpdate.bind(this);
        this.handleEditorReady = this.handleEditorReady.bind(this);
    }

    componentDidMount() {
        const {alertId} = this.props;
        if(!alertId) return console.log('This is a new alert');        
        return this.setAlertUpdate();
    }

    public setAlertUpdate() {
        const {alertId, alerts} = this.props;
        const alert = alerts.find((alert:any) => alert._id === alertId);
        const {name, title, _id, content, contentRaw, type} = alert;
        this.setState({...this.state, name, title, _id, content, contentRaw, type, editing:true});
    }

    public handleEditorReady(editor:any){
        const {content} = this.state;
        editor.insertHTML(content);
    }
    
    public inputChangeHandler(e: any) {
        const { name, value } = e.target;
        console.log(name, value);
        return this.setState({ ...this.state, [name]: value });
    }

    public validateForm() {
        const { name } = this.state;
        return name !== '' && name !== null;
    }

    public submit() {
        const { addAlert, reset } = this.props;
        const { name, title, content, contentRaw, type } = this.state;
        if (!this.validateForm()) return this.setState({ ...this.state, error: true });
        addAlert({ name, title, content, contentRaw, type } as IAlert);
        this.setState({ ...this.state, name: '', title: '', content: '', contentRaw: '', type: '', error: false });
        reset();
    }

    public update() {
        const { updateAlert, reset } = this.props;
        const { _id, name, title, content, contentRaw, type } = this.state;
        if (!this.validateForm()) return this.setState({ ...this.state, error: true });
        updateAlert({ _id, name, title, content, contentRaw, type } as IAlert);
        this.setState({ ...this.state, name: '', title: '', content: '', contentRaw: '', type: '', error: false, _id: '', editing: false });
        reset();
    }

    public cancel() {
        const { reset } = this.props;
        this.setState({ ...this.state, name: '', title: '', content: '', contentRaw: '', type: '', error: false, _id: '', editing: false });
        reset();
    }

    public textFieldChange(html: any, text: any) {
        this.setState({ ...this.state, content: html, contentRaw: text });
    }

    public render() {
        const { classes } = this.props;
        const { name, title, content, type, error, editing } = this.state;
        return (
            <form className={classes.root} noValidate autoComplete="off">
                {editing ? <h2>Update Alert</h2> : <h2>Add Alert</h2>}
                <Container>
                    <TextField error={error} required name="name" label="Name" value={name || ''} onChange={this.inputChangeHandler} />
                    <TextField error={error} required name="title" label="Title" value={title || ''} onChange={this.inputChangeHandler} />
                    <FormControl className={classes.formControl} required>
                        <InputLabel id="state-select">Alert Type</InputLabel>
                        <Select value={type || ''} name="type" onChange={this.inputChangeHandler}>
                            <MenuItem value="snack">Snack Bar</MenuItem>
                            <MenuItem value="dialog">Dialog</MenuItem>
                        </Select>
                    </FormControl>
                    <TrixEditor  autoFocus={false} className={classes.trixEditor} value={content} placeholder="Alert content..." onChange={this.textFieldChange} onEditorReady={this.handleEditorReady}/>

                    {editing ?
                            <div>
                                <Button variant="contained" color="primary" onClick={this.update}>Update Alert</Button>&nbsp;&nbsp;                            
                                <Button variant="contained" color="secondary" onClick={this.cancel}>Cancel</Button>
                            </div>

                        :
                            <div >
                                <Button variant="contained" color="primary" onClick={this.submit}>Add Alert</Button>&nbsp;&nbsp;                            
                                <Button variant="contained" color="secondary" onClick={this.cancel}>Cancel</Button>
                            </div>
                    }
                </Container>
            </form>
        );
    }
}

const mapProps = (app:any) => ({alerts: app.rootReducer.alerts}); 
const actions = (dispatch: Dispatch) => ({
    addAlert: (data: IAlert) => dispatch({ type: ADD_ALERT, payload: data }),
    updateAlert: (data: IAlert) => dispatch({ type: UPDATE_ALERT, payload: data })
});
export default connect(mapProps, actions)(withStyles(styles)(AlertForm));